import { ToolName } from '@/modules/Editor/tools/types'
import type { Editor } from '@/modules/Editor/editor'

import { retrieveAutoAnnotateData } from './utils/retrieveAutoAnnotateData'
import { isVideoSubAnnotations } from '@/modules/Editor/models/annotation/annotationKindValidator'
import { isPreselectedModelAutoAnnotate } from './utils'

export const resume = (editor: Editor, isManual: boolean = false): void => {
  const { selectedAnnotation } = editor.activeView.annotationManager
  if (!selectedAnnotation) {
    return
  }

  if (!isManual) {
    // Important! Without this line e2e tests fails trying to activate auto annotate tool with SAM tool
    const isAutoAnnotateModel = isPreselectedModelAutoAnnotate(editor)
    if (isAutoAnnotateModel && isVideoSubAnnotations(selectedAnnotation.subAnnotations)) {
      return
    }
  }

  const autoAnnotateData = retrieveAutoAnnotateData(selectedAnnotation.id, editor.activeView)
  if (!autoAnnotateData) {
    return
  }

  editor.toolManager.activateTool(ToolName.Clicker)
  editor.callCommand('clicker_tool.init', selectedAnnotation, autoAnnotateData)
}
